import React from 'react';
import { Modal } from 'antd';
import { useIsManagementUser } from '../../context/hooks';
import BusinessDetails from './BusinessDetails';
import ManagementProfile from './ManagementProfile';
import css from './AccountProfileModal.module.css';
import { useProfileModal } from './ProfileModalContext';

const AccountProfileModal = () => {
  const isManagementUser = useIsManagementUser();
  const { isOpen, closeProfile } = useProfileModal();

  return (
    <Modal
      title="Profile"
      open={isOpen}
      onCancel={closeProfile}
      footer={null}
      destroyOnClose
      maskClosable
      width="min(1040px, 88vw)"
      className={css.modal}
    >
      <div className={css.body}>{isManagementUser ? <ManagementProfile variant="modal" /> : <BusinessDetails variant="modal" />}</div>
    </Modal>
  );
};

export default AccountProfileModal;
